module.exports = __webpack_public_path__ + "img/logo.8a01c8e8.png";